// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"16a7747b","736":"ba620f07"}[chunkId] + ".chunk.css";
};